import BadgeBase from "../BadgeBase";

const channelConfig = {
  whatsapp_api: { label: "WhatsApp API", tone: "success" },
  whatsapp: { label: "WhatsApp API", tone: "success" },
  sms: { label: "SMS", tone: "warning" },
  email: { label: "Email", tone: "blue" },
};

export default function ChannelBadge({ value, size = "md", sx }) {
  const normalizedValue = String(value || "").trim().toLowerCase();
  const config = channelConfig[normalizedValue] || {
    label: value || "Canal",
    tone: "neutral",
  };

  return (
    <BadgeBase tone={config.tone} size={size} sx={sx}>
      {config.label}
    </BadgeBase>
  );
}
